// Floating action banner for bulk-selected accounts in the Chart of accounts table.
// Portal-rendered so it floats over everything, pinned to the bottom-center.
// Appears whenever at least one row is selected; dismiss (X) clears the selection.

import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

interface BulkSelectBannerProps {
  count: number;
  onMakeInactive: () => void;
  onLockAccounts: () => void;
  onDismiss: () => void;
}

export default function BulkSelectBanner({ count, onMakeInactive, onLockAccounts, onDismiss }: BulkSelectBannerProps) {
  if (count === 0) return null;
  return createPortal(
    <div
      role="dialog"
      aria-label="Bulk account actions"
      className="fixed left-1/2 -translate-x-1/2 bg-ink text-white rounded-xl shadow-[0_12px_30px_rgba(14,26,26,0.3)] py-2.5 pl-5 pr-2 inline-flex items-center gap-2.5 z-50"
      style={{ bottom: 24 }}
    >
      <span className="font-bold text-[12.5px] mr-1 whitespace-nowrap">
        {count} account{count === 1 ? "" : "s"} selected
      </span>
      <button
        type="button"
        onClick={onMakeInactive}
        className="bg-white/10 border border-white/20 text-white rounded-md px-3 py-1.5 text-[12px] font-semibold cursor-pointer hover:bg-white/20 whitespace-nowrap"
      >
        Make inactive
      </button>
      <button
        type="button"
        onClick={onLockAccounts}
        className="bg-white/10 border border-white/20 text-white rounded-md px-3 py-1.5 text-[12px] font-semibold cursor-pointer hover:bg-white/20 whitespace-nowrap"
      >
        Lock accounts
      </button>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss selection"
        className="bg-transparent border-none text-white/80 hover:text-white cursor-pointer ml-1 inline-flex items-center justify-center w-7 h-7 rounded-md hover:bg-white/10"
      >
        <X size={16} />
      </button>
    </div>,
    document.body
  );
}